import React from "react";
import "./CompaniaDesactivada.css";

export default function CompaniaDesactivada({ mensaje }) {
  const texto = String(mensaje || "").trim() ||
    "La página de esta compañía ha sido desactivada por la administración. Para solicitar la reactivación, comuníquese con la Comandancia.";
  return (
    <div className="pagina-desactivada">
      <div className="desactivada-card">
        <h1>Página desactivada</h1>
        <p className="mensaje">{texto}</p>
      </div>
    </div>
  );
}
